<template>
    <b-modal ref="profile_modal" size="lg" bodyClass="p-0" v-bind:no-close-on-backdrop=true :hide-header=true v-model="is_show_modal" :dialogClass=dialog_class_draw>

        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>

        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">{{__t('AGGREGATOR_EDIT')}}:{{this.agr.human_name.toUpperCase()}}</span>
                </h2>

                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show">
                <b-overlay :show="is_load" rounded="sm">
                    <template v-slot:overlay>
                        <div class="text-center">
                            <b-icon icon="stopwatch" font-scale="2" animation="cylon"></b-icon>
                            <div class="mt-3">
                                <div class="">{{cur_status}}</div>
                            </div>
                        </div>
                    </template>

                    <div class="panel-content">
                        <div class="d-flex flex-column align-items-center justify-content-center p-4">
                            <h5 class="mb-0 fw-700 text-center mt-3">
                                {{this.agr.human_name}}
                            </h5>
                        </div>

                        <div class="panel-tag">
                            {{__t((this.agr.type + "_base_info").toUpperCase())}}
                        </div>

                        <div>
                            <b-tabs content-class="mt-3" v-if="!is_load">
                                <b-tab v-for="(tab,index) in tabs" @click="set_active(index)" :key="index" :active="tab.is_active">
                                    <template slot="title">
                                        {{ tab.title }}
                                    </template>

                                    <component v-bind:is="tab.index"></component>
                                </b-tab>
                            </b-tabs>
                        </div>

                    </div>
                </b-overlay>
            </div>
        </div>

        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                <button type="button" @click="close" class="btn btn-secondary waves-effect waves-themed">
                    {{ __t('CLOSE') }}
                </button>

                <button type="button" v-on:click="save" class="btn btn-primary waves-effect waves-themed">
                    {{ __t('SAVE') }}
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>

import agr_general_settings from "./tabs/agr_general_settings";
import {createHelpers} from "vuex-map-fields";
import vSelect from 'vue-select';
const {mapFields} = createHelpers({
    getterType: 'aggregator/getAggregatorStateField',
    mutationType: 'aggregator/updateAggregatorStateField',
});

export default {
    name: "base_aggregator_settings",
    props: {
        modal_position: {
            type: String,
            default: "right"
        },
    },
    components : {
        agr_general_settings,
        vSelect
    },

    created() {
        EventBus.$on("show_aggregator_base_settings", this.open);
    },
    data() {
        return {
            locales : [],
            cur_status: "",
            is_save: false,
            is_show_modal: false,
            is_load: false,
            tabs: [
                {
                    'title': this.__t('GENERAL_AGGREGATOR'),
                    'is_active': true,
                    'index': 'agr_general_settings',
                },
            ]
        }
    },

    methods: {

        open() {
            this.is_show_modal = true;
        },
        close() {
            this.is_show_modal = false;
        },

        save() {
            this.is_load = true;
            this
                .save_params()
                .then(({data}) => {
                    this.is_load = false;
                    this.close();
                    EventBus.$emit('reload_provider');

                })
                .catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        delay_time : 9000,
                        position : "b-toaster-top-left",
                        title: this.__t("ERR_SAVE_POS")
                    })
                });
        },

        async save_params() {
            return agr_api.put('/aggregators/' + parseInt(this.agr.id) + "/settings", {
               // "pos_params"   : this.aggregator_item.aggregators_params,
                "basic_params" : this.aggregator_item.basic_params
            });
        },

        get_tab_title (tab) {
            if(tab.count > 0) {
                return tab.title;
            }
            return tab.title;
        },


        set_active (obj) {
            for (let tab in this.tabs) {
                if(this.tabs.hasOwnProperty(tab)) {
                    this.tabs[tab].is_active = false;
                }
            }

            this.tabs[obj].is_active = true;
            EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
        },
    },

    computed : {

        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-lg";
            }
            return "modal-dialog-right modal-lg";
        },

        agr() {
            return this.aggregator_item.provider;
        },

        can_remove() {
            return this.aggregator_item.is_init;
        },

        ...mapFields([
            'aggregator_item'
        ])
    }
}
</script>

<style scoped>

</style>
